






















import { Prop, Component, Vue } from "vue-property-decorator";
import InvoiceRow from "./InvoiceRow.vue";
import VTh from "./VTh.vue";

@Component({
  components: {
    VTh,
    InvoiceRow
  }
})
export default class InvoiceHeader extends Vue {
  @Prop({ required: true }) fields!: string[];
  @Prop({ required: true }) styleGridColumn!: string;

  getGridStyle(spanRow: number) {
    let style: any = {};
    if (spanRow === 0) {
      style.gridRow = "span 2";
    } else {
      style.gridColumn = `span ${spanRow}`;
    }
    return style;
  }
}
